import { useMemo } from 'react';
import { CustomContent, CustomGalleryItem, FieldOptionsWithRouter } from '../types';
import {
  getComplexContentObjectArray,
  getContentBlockField,
  getPlaceholderForPreview,
  shouldShowContentBlockPlaceholders
} from '../utils';
import { EMPTY_CONTENT_BLOCK_IMAGE } from '../constants';

export const useContentBlockGalleryItems = (
  customContent: CustomContent[],
  { slug, router }: FieldOptionsWithRouter
) =>
  useMemo<CustomGalleryItem[]>(() => {
    const content =
      getComplexContentObjectArray<CustomGalleryItem>(
        getContentBlockField(customContent, 'custom-gallery', { slug })
      ) || [];

    if (!content.length && shouldShowContentBlockPlaceholders(router)) {
      content.push({
        image: EMPTY_CONTENT_BLOCK_IMAGE,
        description: 'Description'
      } satisfies CustomGalleryItem);
    }

    return content.reduce((acc, i) => {
      const item = {
        image: i.image || getPlaceholderForPreview(router, EMPTY_CONTENT_BLOCK_IMAGE, ''),
        description: i.description || getPlaceholderForPreview(router, 'Description', '')
      } satisfies CustomGalleryItem;
      if (item.image && item.description) {
        acc.push(item);
      }
      return acc;
    }, [] as CustomGalleryItem[]);
  }, [customContent, router, slug]);
